// Import images
import profileImage from './profile.jpg';

// Export images
export const images = {
  profile: profileImage,
};

// Default export
export default images;
